import { render, staticRenderFns } from "./vacancy-list.vue?vue&type=template&id=5305897d&scoped=true"
import script from "./vacancy-list.vue?vue&type=script&lang=js"
export * from "./vacancy-list.vue?vue&type=script&lang=js"
import style0 from "./vacancy-list.vue?vue&type=style&index=0&id=5305897d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305897d",
  null
  
)

export default component.exports